import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import {
  DetailTable,
  CheckForDetail
} from "MODULES/shared/components/DetailTable";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import {
  ACCOUNTING,
  SALES,
  WAREHOUSE_EXPERT,
  WAREHOUSE_MANAGER,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import pojo from "LIB/pojos";
import string from "LIB/strings";
import Section from "MODULES/shared/components/Section";
import ShippingAddress from "MODULES/Orders/shared/ShippingAddress";
import { FinalDestinationDetails } from "MODULES/shared/components/FinalDestination";
import { mapSOToForm } from "MODULES/SalesOrders/helpers";
import {
  COMPANY_ID,
  CONTACT_ID,
  DISCREET,
  SHIP_TO,
  SHIP_TO_COMPANY_ADDRESS_ID,
  SHIP_TO_COMPANY_ID,
  SHIP_TO_CUSTOMER_ADDRESS_ID,
  SHIP_TO_FOB,
  SHIP_TO_SHIPPING_ADDRESS,
  SHIP_TO_SHIPPING_METHOD,
  SHIP_TO_TYPE
} from "APP_ROOT/constants";
import { hasAnyOfRolesOrSubroles } from "MODULES/users/helpers";
import Form from "./Form";
import { PICTURES_REQUIRED, SPECIAL_INSTRUCTIONS } from "../../../../constants";

function ShipTo({ salesOrder, currentUser }) {
  const initialValues = pojo(mapSOToForm(salesOrder.toJS())).pick(
    COMPANY_ID,
    CONTACT_ID,
    SHIP_TO_TYPE,
    SHIP_TO_FOB,
    SHIP_TO_COMPANY_ID,
    SHIP_TO_COMPANY_ADDRESS_ID,
    SHIP_TO_CUSTOMER_ADDRESS_ID,
    SHIP_TO_SHIPPING_ADDRESS,
    SHIP_TO_SHIPPING_METHOD,
    DISCREET,
    "customer_to_provide_own_paperwork",
    SPECIAL_INSTRUCTIONS,
    "final_destination_name",
    "final_destination_phone",
    "final_destination_email",
    "final_destination_reference",
    "final_destination_address",
    "final_destination_company_name",
    PICTURES_REQUIRED
  );

  const userCanEditShipToFields = hasAnyOfRolesOrSubroles(
    currentUser,
    [ACCOUNTING, SALES],
    [WAREHOUSE_EXPERT, WAREHOUSE_MANAGER, WAREHOUSE_LOGISTICS_DIRECTOR]
  );

  const renderForm = close => (
    <Form
      close={close}
      salesOrder={salesOrder.toJS()}
      initialValues={initialValues}
    />
  );

  return (
    <Section
      title="Ship To"
      modal={{
        title: "Edit Sales Order - Ship To",
        content: renderForm
      }}
      editable={userCanEditShipToFields && !salesOrder.get("partially_shipped")}
    >
      <DetailTable>
        <CheckForDetail
          label="Discreet"
          value={salesOrder.get("discreet")}
          icon="eye-slash"
        />
        <CheckForDetail
          label="Special Instructions"
          value={!string(salesOrder.get("special_instructions")).empty()}
        />
        <CheckForDetail
          label="Customer P/W"
          value={salesOrder.get("customer_to_provide_own_paperwork")}
        />
      </DetailTable>
      <hr className="hr-xs hr-dashed" />
      <ShippingAddress shippingType={SHIP_TO} record={salesOrder} />
      <hr className="hr-xs hr-dashed" />
      <FinalDestinationDetails shippingType={SHIP_TO} record={salesOrder} />
    </Section>
  );
}

ShipTo.propTypes = {
  salesOrder: T.instanceOf(Map).isRequired,
  ...WithCurrentUser
};

export default withCurrentUser(withSalesOrder(ShipTo));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/ShipTo/ShipTo.jsx